import ClientsService from '../../services/ClientsService';
import RequestList from "../../services/RequestList";

const state = {
    sentRequestCount: 0,
    clients: {}
}

const getters = {
    fetching(state) {
        return state.sentRequestCount > 0;
    }
}

const mutations = {
    SET_CLIENTS(state, clients) {
        let clientsKeyById = {};

        clients.forEach(client => {
            clientsKeyById[client.id] = client;
        });

        state.clients = clientsKeyById;
    },
    INCREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount++;
    },
    DECREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount--;
    }
}

const actions = {
    async fetchClients({ commit }) {
        commit('INCREMENT_SENT_REQUEST_COUNT');

        try {
            let requestList = new RequestList();
            let {
                data
            } = await ClientsService.list(requestList);

            commit('SET_CLIENTS', data.value.clients);
        } finally {
            commit('DECREMENT_SENT_REQUEST_COUNT');
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}